import {
    useAddCompositesToRole,
    useDeleteCompositesToRole,
    useFindAllRoles,
    useFindRoleCompositesByName
} from "hooks/query/role-query"
import {useCallback, useState} from "react"
import {Role} from "dto/Role"
import {NotificationType, showNotification} from "common/Notification"

export function useCompositeState(roleName: string) {
    const {data: roles} = useFindAllRoles()
    const {data: composites} = useFindRoleCompositesByName(roleName)
    const addCompositeMutate = useAddCompositesToRole()
    const deleteCompositeMutate = useDeleteCompositesToRole()
    const [sourceItem, setSourceItem] = useState<Role | undefined>()
    const [targetItem, setTargetItem] = useState<Role | undefined>()

    const existCompositeRoleMap = composites?.filter(role => !role.clientRole).reduce((map: itemMapType, role: Role) => {
        console.log("role : ", role.name)
        map[role.name] = true
        return map
    }, {}) || {}

    const sourceList = roles?.filter(role => {
        return (role.name !== roleName) && !existCompositeRoleMap[role.name]
    }) || []

    const targetList = composites?.filter(role => {
        return !role.clientRole
    }) || []

    const addComposite = useCallback(() => {
        if (!sourceItem) {
            showNotification("선택된 Role이 없습니다")
            return
        }
        addCompositeMutate.mutate({
            roleName,
            itemName: sourceItem.name
        }, {
            onSuccess: () => {
                setSourceItem(undefined)
                setTargetItem(undefined)
                showNotification("Role 이 추가 되었습니다", NotificationType.SUCCESS)
            },
            onError: () => {
                showNotification("Role 이 추가 되지 않았습니다", NotificationType.ERROR)
            }
        })
    }, [addCompositeMutate, roleName, sourceItem])

    const deleteComposite = useCallback(() => {
        if (!targetItem) {
            showNotification("선택된 Role이 없습니다")
            return
        }
        deleteCompositeMutate.mutate({
            roleName,
            itemName: targetItem.name
        }, {
            onSuccess: () => {
                setSourceItem(undefined)
                setTargetItem(undefined)
                showNotification("Role 이 삭제 되었습니다", NotificationType.SUCCESS)
            },
            onError: () => {
                showNotification("Role 이 삭제 되지 않았습니다", NotificationType.ERROR)
            }
        })
    }, [deleteCompositeMutate, roleName, targetItem])

    return {
        sourceItem, targetItem,
        sourceList, targetList, addComposite, deleteComposite,
        setSourceItem, setTargetItem, composites,
    }
}

interface itemMapType {
    [name: string]: boolean
}
